import { tsValidateValue } from '@nu-art/ts-common';
import { FhirEpicEnvs } from './types.js';
export const Validator_FhirEpicEnv = tsValidateValue([...FhirEpicEnvs], false);
//# sourceMappingURL=validator.js.map